var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector-15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.92947 5.95127L5.0343 1.84544C5.22576 1.5764 5.53555 1.41663 5.86576 1.41663C6.19596 1.41663 6.50576 1.5764 6.69722 1.84544L10.0913 5.95127C10.3692 6.29861 10.4342 6.77044 10.2604 7.17995C10.0867 7.58946 9.70221 7.87062 9.2593 7.9121H2.7593C2.31678 7.86991 1.93301 7.58848 1.75976 7.1791C1.58651 6.76972 1.65167 6.29831 1.92947 5.95127Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0913 12.0396L6.9843 16.1454C6.7929 16.4149 6.48284 16.575 6.1523 16.575C5.82176 16.575 5.5117 16.4149 5.3203 16.1454L1.92947 12.0396C1.65167 11.6925 1.58651 11.2211 1.75976 10.8117C1.93301 10.4024 2.31678 10.1209 2.7593 10.0787H9.2593C9.70221 10.1202 10.0867 10.4014 10.2604 10.8109C10.4342 11.2204 10.3692 11.6922 10.0913 12.0396Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.65e69abe44aa16011214f89be4f9551c.svg";
export { ForwardRef as ReactComponent };